// extracted by mini-css-extract-plugin
export var chip = "_bz-0";
export var filterDropdown = "_bz-5";
export var filterItem = "_bz-6";
export var icon = "_bz-1";
export var removeButton = "_bz-3";
export var removeIcon = "_bz-4";
export var separator = "_bz-2";